import createSelectors from './createSelectors';
import AnswersSheetSession from '../models/AnswersSheetSession';

const Select = createSelectors(AnswersSheetSession, {});

export default Select;
